import { render, staticRenderFns } from "./incomeTaxProofPlan.vue?vue&type=template&id=788669f0&scoped=true"
import script from "./incomeTaxProofPlan.vue?vue&type=script&lang=js"
export * from "./incomeTaxProofPlan.vue?vue&type=script&lang=js"
import style0 from "./incomeTaxProofPlan.vue?vue&type=style&index=0&id=788669f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788669f0",
  null
  
)

export default component.exports